import { useCallback, useEffect, useMemo, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/esm/Button";
import { FaCheckCircle, FaClock, FaQuestionCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, getDataPDF, postDataAPI } from "../utils/fetchData";
import LoginRequest from "./loginRequest";
import "./pdfreaderstyles.css";
import PdfViewer from "./pdfviewer";
import Test from "./test";

const HEADER_STYLE = {
	color: "#fff",
	background: "#0C67DA",
	textAlign: "center",
	padding: "10px",
	fontSize: "23px",
};
const COURSE_IMAGE_STYLE = { width: "100%" };
const COURSE_TITLE_STYLE = {
	fontSize: "20px",
	fontWeight: "500",
	minHeight: "36px",
	color: "#fff",
	paddingTop: "10px",
};
const SECTION_HEADER_STYLE = {
	fontWeight: 500,
	fontSize: "15px",
};
const PDF_ICON_STYLE = { height: "20px" };
const PDF_LINK_STYLE = { color: "green", paddingLeft: "10px" };
const FINAL_ASSESSMENT_HEADER_STYLE = { fontWeight: 900, color: "#36BB7D" };
const FINAL_ASSESSMENT_BTN_STYLE = {
	background: "#20ce8f",
	border: "none",
	borderRadius: "4px",
};
const CARD_HEADER_STYLE = {
	background: "#203F54",
	color: "#fff",
	padding: "10px",
	fontSize: "18px",
	textAlign: "center",
};
const CARD_BODY_STYLE = {
	background: "#fff",
};
const ASSESSMENT_INFO_STYLE = {
	textAlign: "center",
	fontSize: "20px",
	padding: "10px",
};
const NOTE_STYLE = { margin: "2rem 0", textAlign: "center" };

const Pdfreader = () => {
	const { auth } = useSelector((state) => state);
	const dispatch = useDispatch();
	const [pdfFile, setPdfFile] = useState("");
	const [data, setData] = useState(null);
	const [viewChange, setViewChange] = useState("");
	const [startTest, setStartTest] = useState("");
	const [sections, setSections] = useState([]);
	const [selectedOptions, setSelectedOptions] = useState({});
	const [started, setStarted] = useState(false);
	const [results, setResults] = useState(null);
	const [score, setScore] = useState(0);

	const isMobile = window.innerWidth <= 780;

	// Fetch course data
	useEffect(() => {
		const fetchCourse = async () => {
			if (!auth.token) return;
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
			try {
				const res = await getDataAPI(
					`getCourseById/${window.location.pathname.split("/")[2]}/${
						auth.user.id
					}`,
					auth.token,
				);
				if (res.data.course) {
					setData(res.data.course);
				}
			} catch (err) {
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch course data" },
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};
		fetchCourse();
	}, [auth, dispatch]);

	// Extract unique sections from textlist
	useEffect(() => {
		if (data && data.textlist) {
			const tempSections = Array.from(
				new Set(data.textlist.map((v) => v.section)),
			);
			setSections(tempSections);
		}
	}, [data]);

	const handleOptionChange = useCallback((questionIndex, selectedOption) => {
		setSelectedOptions((prevState) => ({
			...prevState,
			[questionIndex]: selectedOption,
		}));
	}, []);

	// const handleStart = useCallback(async () => {
	// 	dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

	// 	try {
	// 		const res = await postDataAPI(
	// 			"checkexameligibilitytime",
	// 			{
	// 				userid: auth.user.id,
	// 				courseid: data.id,
	// 			},
	// 			auth.token
	// 		);
	// 		if (res.status === 200) {
	// 			try {
	// 				const resp = await postDataAPI(
	// 					"examstarted",
	// 					{
	// 						userid: auth.user.id,
	// 						courseid: data.id,
	// 					},
	// 					auth.token
	// 				);
	// 				if (resp.status === 200) {
	// 					setStartTest(true);
	// 					setViewChange("");
	// 					setStarted(true);
	// 					dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
	// 				}
	// 			} catch (erro) {
	// 				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
	// 				dispatch({
	// 					type: GLOBALTYPES.ALERT,
	// 					payload: {
	// 						error: erro.response?.data?.msg || "Failed to start exam",
	// 					},
	// 				});
	// 			}
	// 		} else {
	// 			alert(res.data.msg);
	// 		}
	// 	} catch (err) {
	// 		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
	// 		dispatch({
	// 			type: GLOBALTYPES.ALERT,
	// 			payload: {
	// 				error: err.response?.data?.msg || "Failed to check eligibility",
	// 			},
	// 		});
	// 	}
	// }, [auth, data, dispatch]);
	const handleStart = useCallback(async () => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		try {
			const res = await postDataAPI(
				"checkexameligibilitytime",
				{
					userid: auth.user.id,
					courseid: data.id,
				},
				auth.token,
			);

			// Always turn off loading after response
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });

			if (res.status === 200) {
				try {
					const resp = await postDataAPI(
						"examstarted",
						{
							userid: auth.user.id,
							courseid: data.id,
						},
						auth.token,
					);
					if (resp.status === 200) {
						setStartTest(true);
						setViewChange("");
						setStarted(true);
					}
				} catch (erro) {
					dispatch({
						type: GLOBALTYPES.ALERT,
						payload: {
							error: erro.response?.data?.msg || "Failed to start exam",
						},
					});
				}
			} else {
				// Show message, but loading is already off
				alert(res.data.msg);
			}
		} catch (err) {
			// Also turn off loading on error
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: {
					error: err.response?.data?.msg || "Failed to check eligibility",
				},
			});
		}
	}, [auth, data, dispatch]);
	const handleSubmit = useCallback((answers) => {
		setResults(answers);
		setStarted(false);
	}, []);

	// const handleScore = useCallback(
	// 	async (score) => {
	// 		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
	// 		setScore(score);
	// 		if (!data || !data.questionslist) return;
	// 		const percentage = (score / data.questionslist.length) * 100;
	// 		try {
	// 			const res = await postDataAPI(
	// 				"examended",
	// 				{
	// 					userid: auth.user.id,
	// 					courseid: data.id,
	// 					percentage,
	// 				},
	// 				auth.token
	// 			);
	// 			if (res.status === 200) {
	// 				postDataAPI(
	// 					"generatecertificate",
	// 					{
	// 						fullname: auth.user.fullname,
	// 						email: auth.user.email,
	// 						coursetitle: data.coursetitle + " : " + data.subcategory.name,
	// 						courseduration: data.duration,
	// 						percentage,
	// 					},
	// 					auth.token
	// 				).then((res) => {
	// 					console.log("res", res);
	// 					dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
	// 					dispatch({
	// 						type: GLOBALTYPES.ALERT,
	// 						payload: { success: res.data.msg },
	// 					});
	// 				});
	// 			}
	// 		} catch (err) {
	// 			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
	// 			dispatch({
	// 				type: GLOBALTYPES.ALERT,
	// 				payload: {
	// 					error: err.response?.data?.msg || "Failed to submit exam",
	// 				},
	// 			});
	// 		}
	// 	},
	// 	[auth, data, dispatch]
	// );
	const handleScore = useCallback(
		async (score) => {
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
			setScore(score);

			if (!data || !data.questionslist) {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				return;
			}

			const percentage = (score / data.questionslist.length) * 100;
			const isPassed = percentage >= 60;

			try {
				// 1. Mark exam as ended (critical)
				const endExamRes = await postDataAPI(
					"examended",
					{
						userid: auth.user.id,
						courseid: data.id,
						percentage,
					},
					auth.token,
				);

				if (endExamRes.status !== 200) {
					throw new Error(endExamRes.data?.msg || "Failed to end exam");
				}

				// 2. STOP LOADING NOW — user sees result instantly
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: {
						success: `Exam submitted! ${
							isPassed ? "Passed" : "Attendance"
						} certificate will be emailed shortly.`,
					},
				});

				// 3. Fire-and-forget certificate generation
				postDataAPI(
					"generatecertificate",
					{
						fullname: auth.user.fullname,
						email: auth.user.email,
						coursetitle: `${data.coursetitle} : ${data.subcategory.name}`,
						courseduration: data.duration,
						percentage: Math.round(percentage),
					},
					auth.token,
				).catch((err) => {
					console.error("Certificate email failed (non-critical):", err);
					// Optional: notify user later via toast
				});
			} catch (err) {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: {
						error: err.response?.data?.msg || "Failed to submit exam",
					},
				});
			}
		},
		[auth, data, dispatch],
	);
	const fileConversion = useCallback(
		(file) => {
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
			const newfile = { file };
			getDataPDF("getCoursePdf", newfile).then((res) => {
				const fileBlob = new Blob([res.data], { type: "application/pdf" });
				const fileURL = URL.createObjectURL(fileBlob);
				setPdfFile(fileURL);
				setViewChange(false);
				setStartTest("");
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			});
		},
		[dispatch],
	);

	const renderSectionAccordions = useMemo(
		() =>
			sections.map((c) => {
				if (c !== "") {
					return (
						<Accordion key={c} style={{ margin: "10px 0" }}>
							<Accordion.Item eventKey={c}>
								<Accordion.Header style={{ borderBottom: "1px solid #ddd" }}>
									<div style={SECTION_HEADER_STYLE}>{c}</div>
								</Accordion.Header>
								<Accordion.Body
									style={{ padding: "15px", borderTop: "1px solid #ddd" }}>
									{data.textlist.map((e, index) => {
										if (e.section === c) {
											return (
												<Accordion key={index} style={{ marginBottom: "5px" }}>
													<Accordion.Item eventKey={index}>
														<Accordion.Header>
															<div style={SECTION_HEADER_STYLE}>{e.name}</div>
														</Accordion.Header>
														<Accordion.Body style={CARD_BODY_STYLE}>
															<div
																onClick={() => fileConversion(e.file)}
																style={{ cursor: "pointer" }}>
																<img
																	alt="pdf"
																	src="../images/PDF.svg"
																	style={PDF_ICON_STYLE}
																/>
																<span style={PDF_LINK_STYLE}>{e.name}</span>
															</div>
														</Accordion.Body>
													</Accordion.Item>
												</Accordion>
											);
										}
										return null;
									})}
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					);
				} else {
					return data.textlist.map((e, index) => {
						if (e.section === c) {
							return (
								<Accordion key={index} style={{ margin: "10px 0" }}>
									<Accordion.Item eventKey={index}>
										<Accordion.Header>
											<div style={SECTION_HEADER_STYLE}>{e.name}</div>
										</Accordion.Header>
										<Accordion.Body style={CARD_BODY_STYLE}>
											<div
												onClick={() => fileConversion(e.file)}
												style={{ cursor: "pointer" }}>
												<img
													alt="pdf"
													src="../images/PDF.svg"
													style={PDF_ICON_STYLE}
												/>
												<span style={PDF_LINK_STYLE}>{e.name}</span>
											</div>
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							);
						}
						return null;
					});
				}
			}),
		[sections, data, fileConversion],
	);
	if (!auth.user) {
		return <LoginRequest />;
	}

	return (
		<div className="App pdf-container">
			<div
				style={{
					...HEADER_STYLE,
					fontSize: isMobile ? "18px" : "23px",
				}}>
				{data && data.coursetitle}
			</div>
			<div className="row">
				<div className="col-12 col-md-3" style={{ background: "#000" }}>
					<div style={{ padding: "25px" }}>
						<div className="pt-4">
							<img
								src={data && data.courseimage}
								style={COURSE_IMAGE_STYLE}
								onError={(e) => {
									e.target.src = "../images/common-couse-image.png";
								}}
								alt="Course"
							/>
						</div>
						<div style={COURSE_TITLE_STYLE}>{data && data.coursetitle}</div>
					</div>
					<div style={HEADER_STYLE}>Course Study Materials</div>
					<div>{data && data.textlist && renderSectionAccordions}</div>
					<Accordion style={{ margin: "10px 0" }}>
						<Accordion.Item eventKey={data && data.files?.length}>
							<Accordion.Header>
								<div style={FINAL_ASSESSMENT_HEADER_STYLE}>
									Final Assessment
								</div>
							</Accordion.Header>
							<Accordion.Body style={CARD_BODY_STYLE}>
								<div
									onClick={() => {
										window.scrollTo(0, 0);
										setViewChange(true);
									}}
									style={{ cursor: "pointer" }}>
									<span style={PDF_LINK_STYLE}>Final Assessment</span>
								</div>
							</Accordion.Body>
						</Accordion.Item>
					</Accordion>
				</div>
				<div className="col-12 col-md-9">
					{viewChange === false && <PdfViewer pdfFile={pdfFile} />}
					{viewChange === true && (
						<div
							style={{
								background: "#fff",
								height: "100vh",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								flexDirection: "column",
							}}>
							<div
								className="card"
								style={{ width: "45vw", paddingBottom: "15px" }}>
								{/* <div style={CARD_HEADER_STYLE}>{data.coursetitle}</div> */}
								{data.questionslist.length > 0 ? (
									<>
										<div style={CARD_HEADER_STYLE}>Final Assessment</div>
										<div
											className="row"
											style={{ paddingTop: "10px", paddingBottom: "10px" }}>
											<div
												className="col-4"
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}>
												<FaQuestionCircle
													style={{
														color: "#36BB7D",
														marginRight: 10,
														fontSize: "1.7em",
													}}
												/>
												{data.questionslist.length}
												<br />
												Questions
											</div>
											<div
												className="col-4"
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}>
												<FaClock
													style={{
														color: "#ebb813",
														marginRight: 10,
														fontSize: "1.7em",
													}}
												/>
												{data.questionslist.length *
													parseInt(data.questionsduration)}
												<br />
												Minutes
											</div>
											<div
												className="col-4"
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}>
												<FaCheckCircle
													style={{
														color: "#203F54",
														marginRight: 10,
														fontSize: "1.7em",
													}}
												/>
												{data.questionslist.length}
												<br />
												Marks
											</div>
										</div>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}>
											<Button
												style={FINAL_ASSESSMENT_BTN_STYLE}
												onClick={handleStart}>
												Start test
											</Button>
										</div>
									</>
								) : (
									<div style={ASSESSMENT_INFO_STYLE}>
										No Assessment for this course
									</div>
								)}
							</div>
							<div style={NOTE_STYLE}>
								<ul
									style={{
										textAlign: "left",
										listStyle: "starting",
										margin: "0 50px",
									}}>
									Note:
									<li>
										{" "}
										Achieve 60% or more to earn a Certificate of Completion.
										Below 60% will earn a Certificate of Attendance.
									</li>
									<li>
										Kindly be Informed that the Final Assessment is Conducted
										Only Once and No Re-Attempt will be Permitted for the Same
										Registration.
									</li>{" "}
									<li>
										User can only receive the Certificate only if test is given.
									</li>
								</ul>
							</div>
						</div>
					)}
					{startTest === true && (
						<div
							style={{ background: "#fff", height: "100vh", padding: "10px" }}>
							{/* <div style={CARD_HEADER_STYLE}>{data.coursetitle}</div> */}
							<div
								style={{
									background: "#203F54",
									color: "#fff",
									padding: "10px",
									fontSize: "20px",
									textAlign: "center",
								}}>
								Final Assessment
							</div>
							<div>
								{results ? (
									<div style={{ textAlign: "center", marginTop: "50px" }}>
										<h2>Test Results</h2>
										<p>
											You got{" "}
											{((score / data.questionslist.length) * 100).toFixed(0)}%
										</p>
										{((score / data.questionslist.length) * 100).toFixed(0) >=
										60 ? (
											<>
												<h1 style={{ color: "#006436" }}>Passed</h1>
												<p>
													You will receive a Certificate of Completion at your
													registered email address.
												</p>
											</>
										) : (
											<>
												<h1 style={{ color: "red" }}>Failed</h1>
												<p>
													You will receive a Certificate of Attendance at your
													registered email address.
												</p>
											</>
										)}
									</div>
								) : started ? (
									<Test
										onSubmit={handleSubmit}
										questions={data.questionslist}
										questionsduration={data.questionsduration}
										scoretemp={handleScore}
									/>
								) : null}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Pdfreader;
